/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit CsvFileIcon.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Svg = css({label: 'Svg',
  alignSelf: 'var(--alignSelf)',
marginTop: 'var(--marginTop)',
marginBottom: 'var(--marginBottom)',
marginLeft: 'var(--marginLeft)',
marginRight: 'var(--marginRight)',
opacity: 'var(--opacity)',
width: 'var(--width)',
height: 'var(--height)'})
styles.SvgPath = css({label: 'SvgPath',
  fill: 'var(--fill)'})
styles.SvgPath1 = css({label: 'SvgPath1',
  fill: 'var(--fill)'})

export default function CsvFileIcon({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  alignSelf= "auto",
marginTop= 0,
marginBottom= 0,
marginLeft= 0,
marginRight= 0,
opacity= 1,
width= 100,
height= 100,
fill= "#666"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<svg
 data-testid="CsvFileIcon.Svg"
 data-view-path={dataViewPath}
 viewBox="0 0 100 100"
 style={{'--alignSelf': alignSelf,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--opacity': opacity,'--width': typeof width === 'number' ? `${width}px` : width,'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
 data-testid="CsvFileIcon.SvgPath"
 data-view-path={dataViewPath}
 d="M46.8 8.2h4.5v2h-4.5zM28.8 8.2h4.5v2h-4.5zM37.8 8.2h4.5v2h-4.5zM20.9 9.2v2.5h2v-1.5h1.5v-2h-2.5c-.6 0-1 .5-1 1zM20.9 78.1h2v5.1h-2zM20.9 27h2v5.1h-2zM20.9 16.8h2v5.1h-2zM20.9 37.2h2v5.1h-2zM20.9 67.9h2V73h-2zM20.9 57.7h2v5.1h-2zM20.9 47.4h2v5.1h-2zM22.9 88.3h-2v2.5c0 .6.4 1 1 1h2.5v-2h-1.5v-1.5zM38.3 89.8H43v2h-4.7zM29 89.8h4.7v2H29zM66.3 89.8H71v2h-4.7zM47.7 89.8h4.7v2h-4.7zM57 89.8h4.7v2H57zM77.1 89.8h-1.5v2h2.5c.6 0 1-.4 1-1v-2.5h-2v1.5zM77.1 57.3h2v5.2h-2zM77.1 36.7h2v5.2h-2zM77.1 78h2v5.2h-2zM77.1 47h2v5.2h-2zM77.1 67.7h2v5.2h-2zM79.1 29c0-.3-.1-.5-.3-.7L77 26.5 75.7 28l.1.1h-.1v2h1.5v1.5h2l-.1-2.6zM57.3 11.7h2v-.1l.1.1 1.4-1.4L59 8.5c-.2-.2-.4-.3-.7-.3h-2.5v2h1.5v1.5zM57.3 16.6h2v4.9h-2zM57.3 29c0 .6.4 1 1 1h2.5v-2h-1.5v-1.5h-2V29zM65.8 28h4.9v2h-4.9zM69.186 21.465l1.414-1.414 3.253 3.252-1.414 1.415zM62.692 14.948l1.414-1.414 3.253 3.253-1.414 1.414z"
 style={{'--fill': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<g
 data-testid="CsvFileIcon.SvgGroup"
 data-view-path={dataViewPath}
 className="views-block"
>
<path
 data-testid="CsvFileIcon.SvgPath:1"
 data-view-path={dataViewPath}
 d="M32.1 54.4c.3-.3.7-.4 1.2-.4s.9.1 1.2.4c.3.3.4.7.4 1.3s-.1 1-.4 1.3c-.3.3-.7.4-1.2.4s-.9-.1-1.2-.4c-.3-.3-.4-.7-.4-1.3-.1-.6.1-1 .4-1.3zM38.5 56.6c-.9-.5-1.6-1.2-2.1-2.1-.5-.9-.8-1.9-.8-3.1 0-1.1.3-2.2.8-3.1.5-.9 1.2-1.6 2.1-2.1.9-.5 1.9-.7 3.1-.7 1.1 0 2 .2 2.7.6s1.3.9 1.8 1.5l-1.9 1.8c-.3-.4-.6-.7-1-.9-.4-.2-.9-.3-1.4-.3-.9 0-1.7.3-2.2.9-.6.6-.9 1.4-.9 2.4s.3 1.8.9 2.4c.6.6 1.3.9 2.2.9.5 0 1-.1 1.4-.3.4-.2.7-.5 1-.9l1.9 1.8c-.4.6-1 1.1-1.8 1.5-.7.4-1.6.6-2.7.6-1.1-.1-2.2-.4-3.1-.9zM55.4 48.9c-.4-.3-.9-.7-1.4-.9-.6-.2-1.2-.4-1.9-.4-.6 0-1 .1-1.3.3-.3.2-.5.5-.5.9 0 .3.2.5.5.7.4.2.9.3 1.7.5.9.2 1.7.4 2.3.6.6.2 1.1.6 1.5 1.1.4.5.7 1.1.7 2 0 .7-.2 1.3-.6 1.9s-1 1-1.7 1.3c-.7.3-1.6.5-2.6.5s-1.9-.2-2.8-.5c-.9-.3-1.6-.7-2.2-1.3l1.3-2c.4.4 1 .8 1.8 1.1.7.3 1.4.4 2.1.4.6 0 1.1-.1 1.5-.4s.5-.5.5-.9-.2-.6-.6-.8c-.4-.2-1-.3-1.8-.5-.9-.2-1.6-.4-2.2-.6-.6-.2-1.1-.6-1.5-1-.4-.5-.6-1.1-.6-1.9 0-.6.2-1.2.5-1.8.4-.5.9-1 1.6-1.3.7-.3 1.5-.5 2.5-.5.9 0 1.7.1 2.5.4.8.3 1.4.6 2 1.1l-1.3 2zM60.7 45.8l3 8 3-8h3.1l-4.5 11.3h-3.1l-4.5-11.3h3z"
 style={{'--fill': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}